import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
  Select,
  MenuItem,
} from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  selectDetailStrategies,
  selectDetailLoading,
  selectDetailPeriod,
  TIME_PERIODS,
} from "../../../../../Redux/Reducers/strategyStoreSlice";
import Chart from "../../components/Chart";

const formatReturnDelta = (strategies) => {
  if (strategies.length < 2) return null;
  const main = strategies[0];
  const compare = strategies[1];
  if (main?.periodReturn == null || compare?.periodReturn == null) return null;

  const mainReturn = main.periodReturn ;
  const compareReturn = compare.periodReturn;
  const delta = mainReturn - compareReturn;

  const leader = delta >= 0 ? main : compare;
  const absDelta = Math.abs(delta).toFixed(2);

  return { leaderTitle: leader.title, absDelta };
};

const ComparisonChart = ({ onPeriodChange }) => {
  const strategies = useSelector(selectDetailStrategies);
  const isLoading = useSelector(selectDetailLoading);
  const period = useSelector(selectDetailPeriod);

  const [showPercentage, setShowPercentage] = useState(false);

  const returnDelta = formatReturnDelta(strategies);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          {returnDelta && (
            <>
              <TrendingUpIcon fontSize="small" color="success" />
              <Typography variant="body2">
                <strong>{returnDelta.leaderTitle}</strong>
                {" outperforming by "}
                <Typography component="span" variant="body2" color="success.main" fontWeight={600}>
                    +{returnDelta.absDelta}%
                  </Typography>
              </Typography>
            </>
          )}
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Box display="flex" alignItems="center" gap={1}>
            {strategies.map((strategy, index) => (
              <Box key={strategy.idStrategy} display="flex" alignItems="center" gap={0.5}>
                <Box
                  sx={{
                    width: 16,
                    height: 2,
                    borderRadius: 1,
                    bgcolor: index === 0 ? "primary.main" : ["#ff6b6b", "#ffd93d", "#6bcb77", "#4d96ff", "#ff922b"][index - 1],
                  }}
                />
                <Typography variant="caption" color="text.secondary">
                  {strategy.title}
                </Typography>
              </Box>
            ))}
          </Box>
          <ToggleButtonGroup
            value={showPercentage ? "%" : "NAV"}
            exclusive
            size="small"
            onChange={(_, newValue) => {
              if (newValue !== null) setShowPercentage(newValue === "%");
            }}
          >
            <ToggleButton value="NAV">NAV</ToggleButton>
            <ToggleButton value="%">&nbsp; % &nbsp;</ToggleButton>
          </ToggleButtonGroup>
          <Select value={period} onChange={onPeriodChange} size="small" sx={{ minWidth: 120 }}>
            {TIME_PERIODS.map((timePeriod) => (
              <MenuItem key={timePeriod.key} value={timePeriod.key}>
                {timePeriod.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box sx={{ position: "relative" }}>
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <Chart
          strategies={strategies}
          investmentAmount={null}
          showPercentage={showPercentage}
          period={period}
          isComparison
        />
      </Box>
    </Box>
  );
};

export default ComparisonChart;
